
// var window={ WebViewJavascriptBridge, WVJBCallbacks ,flutter_inappwebview};

export function setupInAppWebViewBridge() {
  return new Promise((resolve, reject) => {
    if (window.flutter_inappwebview) {
      resolve(window.flutter_inappwebview);
    } else {
      window.addEventListener("flutterInAppWebViewPlatformReady", () => {
        if (window.flutter_inappwebview) {
          resolve(window.flutter_inappwebview);
        } else {
          reject("flutter_inappwebview is not available");
        }
      });
    }
  });
}

export function callHandler(handlerName, data) {
  return new Promise((resolve, reject) => {
    if (window.flutter_inappwebview) {
      try {
         window.flutter_inappwebview.callHandler(handlerName, data)
          .then((res) => {
            resolve(res);
          }).catch(() => { 
            window.addEventListener("flutterInAppWebViewPlatformReady", () => {
        if (window.flutter_inappwebview) {
          window.flutter_inappwebview.callHandler(handlerName, data)
          .then((res1) => {
            resolve(res1);
          })
        } else {
          reject("flutter_inappwebview is not available");
        }
      });
          })
      } catch(err) {
        window.addEventListener("flutterInAppWebViewPlatformReady", () => {
        if (window.flutter_inappwebview) {
          window.flutter_inappwebview.callHandler(handlerName, data)
          .then((res) => {
            resolve(res);
          })
        } else {
          reject("flutter_inappwebview is not available");
        }
      });
      }
     
    } else {
      window.addEventListener("flutterInAppWebViewPlatformReady", () => {
        if (window.flutter_inappwebview) {
          window.flutter_inappwebview.callHandler(handlerName, data)
          .then((res) => {
            resolve(res);
          })
        } else {
          reject("flutter_inappwebview is not available");
        }
      });
    }
  });
}
 
export function registerHandler(handlerName, callback) {
  console.log('handlerName1',handlerName)

  setupInAppWebViewBridge()
    .then((bridge) => {
      console.log('bridge',bridge)
      bridge.registerHandler(handlerName, () => {
        console.log('handlerName2',handlerName)
        // 处理来自 Flutter 的请求
        callback()
          .then((response) => {
            responseCallback(response);
          })
          .catch((error) => {
            console.error('Error in executing Flutter handler:', error);
            responseCallback(null);
          });
      });
    })
    .catch((error) => {
      console.error('Error in registering Flutter handler:', error);
    });
}


 
 


// WEBPACK FOOTER //
// ./src/utils/native.js